<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Edit claim amount" @close="onClose")

      .px-6.py-4
        // Description text
        .yz-regular-body-sm.text-neutral-700.mb-4
          | The updated claim amount will be saved and reflected in the invoice. Remarks are optional and will be logged if provided.

        // Summary section
        .mb-4
          .yz-medium-body-xs.text-neutral-700.mb-2 Summary:
          yz-card.pa-3(color="yz-neutral-200" outlined)
            .d-flex.flex-column.gap-3
              // Current claimed amount
              .d-flex.justify-space-between.align-center
                .yz-medium-body-sm.text-neutral-500(style="width: 180px;") Current claimed amount
                .yz-medium-body-sm.text-neutral-700 {{ originalTotalAmount | displayPrice($currency) }}

              // New claim amount
              .d-flex.justify-space-between.align-center
                .yz-medium-body-sm.text-neutral-500(style="width: 180px;") New claim amount
                .yz-medium-body-sm.text-neutral-700 {{ newTotalAmount | displayPrice($currency) }}

              // Total adjustments
              .d-flex.justify-space-between.align-center
                .yz-medium-body-sm.text-neutral-500(style="width: 180px;") Total adjustments
                .yz-medium-body-sm(:class="adjustmentColorClass") {{ totalAdjustment < 0 ? '-' : '' }}{{ Math.abs(totalAdjustment) | displayPrice($currency) }}

        // Remarks field
        .d-flex.flex-column.gap-2
          .yz-medium-body-sm.text-neutral-700 Remarks (optional)
          yz-textarea(v-model="remarks" placeholder="Enter remarks here" :rows="4" hide-details)

      yz-dialog-normal-actions(save-label="Continue" cancel-label="Cancel" @cancel="onClose" @save="onContinue")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    originalTotalAmount: {
      type: Number,
      required: true
    },
    newTotalAmount: {
      type: Number,
      required: true
    },
    totalAdjustment: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      remarks: ''
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    adjustmentColorClass() {
      return this.totalAdjustment >= 0 ? 'text-success' : 'text-danger'
    }
  },
  methods: {
    onClose() {
      this.showDialog = false
      this.$emit('canceled')
    },

    onContinue() {
      const confirmData = {
        currentAmount: this.originalTotalAmount,
        newAmount: this.newTotalAmount,
        totalAdjustment: this.totalAdjustment,
        remarks: this.remarks,
        timestamp: new Date().toISOString()
      }

      this.$emit('confirmed', confirmData)
      this.showDialog = false
    }
  }
}
</script>
